import { useState } from "react";
import "./login.css";
import { BACKEND_URL, API_KEY } from "./config";

export default function Login({ onLogin }) {
    const [kod, setKod] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        // Ověř zadaný kód proti API klíči
        if (kod !== API_KEY) {
            setError("❌ Neplatný přístupový kód.");
            setLoading(false);
            return;
        }

        // Ověř že backend je dostupný
        try {
            const res = await fetch(`${BACKEND_URL}/zdravi`);
            if (!res.ok) throw new Error();
            localStorage.setItem("authenticated", "true");
            onLogin();
        } catch {
            setError("⚠️ Nepodařilo se připojit k serveru.");
        }
        setLoading(false);
    };

    return (
        <div className="login-page">
            <div className="box">
                <div className="login">
                    <div className="loginBx">
                        <h2>Login</h2>
                        <form onSubmit={handleLogin}>
                            <input
                                type="password"
                                placeholder="Přístupový kód"
                                value={kod}
                                onChange={(e) => setKod(e.target.value)}
                                required
                            />
                            <input type="submit" value={loading ? "Přihlašuji..." : "Přihlásit se"} disabled={loading} />
                        </form>
                        <div className="group">
                            <p className="boppe">Boppe s.r.o.</p>
                        </div>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}
